import { useState } from 'react';
import type { PullResponse } from '../api';

interface Props {
  card: PullResponse;
}

const LABELS: Record<string, { keywords: string; upright: string; reversed: string; tap: string }> = {
  pl: { keywords: 'Słowa-klucze', upright: 'W pozycji prostej', reversed: 'W pozycji odwróconej', tap: 'Dotknij kartę' },
  en: { keywords: 'Keywords', upright: 'Upright', reversed: 'Reversed', tap: 'Tap the card' },
  uk: { keywords: 'Ключові слова', upright: 'У прямому', reversed: 'У перевернутому', tap: 'Торкніться карти' },
  ru: { keywords: 'Ключевые слова', upright: 'Прямое', reversed: 'Перевёрнутое', tap: 'Коснитесь карты' },
  hi: { keywords: 'मुख्य शब्द', upright: 'सीधा', reversed: 'उल्टा', tap: 'कार्ड को स्पर्श करें' },
  pt: { keywords: 'Palavras-chave', upright: 'Em pé', reversed: 'Invertida', tap: 'Toque a carta' },
  es: { keywords: 'Palabras clave', upright: 'Derecha', reversed: 'Invertida', tap: 'Toca la carta' },
};

export function CardView({ card }: Props) {
  const [flipped, setFlipped] = useState(false);
  const l = LABELS[card.lang] ?? LABELS.en!;
  const name = card.card.name || (card.lang === 'pl' ? card.card.name_pl : card.card.name_en);
  const bodyText = card.reversed ? card.meaning.reversed : card.meaning.upright;

  return (
    <div className="card-view">
      <div
        className={`card-flip ${flipped ? 'is-flipped' : ''}`}
        role="button"
        tabIndex={0}
        onClick={() => setFlipped(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') setFlipped(true);
        }}
      >
        <div className="card-face card-back">
          <div className="card-back-symbol">✦</div>
          <div className="card-back-hint">{l.tap}</div>
        </div>
        <div className={`card-face card-front ${card.reversed ? 'is-reversed' : ''}`}>
          <img src={`/cards/${card.card.image}`} alt={name} draggable={false} />
        </div>
      </div>

      {flipped && (
        <div className="card-body">
          <h2 className="card-title">
            {name}
            <span className="card-orientation"> · {card.reversed ? l.reversed : l.upright}</span>
          </h2>
          <p className="card-text">{bodyText}</p>
          <div className="card-keywords">
            <span className="card-keywords-label">{l.keywords}:</span>{' '}
            {card.meaning.keywords.map((k, i) => (
              <span key={k} className="card-kw">
                {k}
                {i < card.meaning.keywords.length - 1 && ' · '}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
